import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import { refreshAccessTokenOnce } from './AuthTokenUtil';

type RetryableRequestConfig = InternalAxiosRequestConfig & {
  _authRetry?: boolean;
};

const isAuthLifecycleRequest = (url?: string) => {
  return ['/api/auth/login', '/api/auth/refresh', '/api/auth/logout']
    .some((path) => url?.includes(path));
};

export const installAuthInterceptor = () => {
  axios.interceptors.response.use(
    (response) => response,
    async (error: AxiosError) => {
      const config = error.config as RetryableRequestConfig | undefined;
      const status = error.response?.status;
      const headers = config?.headers as any;
      const authorization = headers?.get?.('Authorization') || headers?.Authorization;

      if (!config || config._authRetry || !authorization || isAuthLifecycleRequest(config.url)
          || (status !== 401 && status !== 403)) {
        return Promise.reject(error);
      }

      config._authRetry = true;
      const accessToken = await refreshAccessTokenOnce();
      if (!accessToken) {
        return Promise.reject(error);
      }

      if (typeof headers?.set === 'function') {
        headers.set('Authorization', `Bearer ${accessToken}`);
      } else {
        config.headers = { ...config.headers, Authorization: `Bearer ${accessToken}` } as any;
      }
      return axios.request(config);
    },
  );
};
